import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import {
  AssigmentDealerModel,
  AssigmentService,
  CreateDealerBalanceRQ,
  DealerBalanceService,
  DealerModel,
  DealerService,
  ShippingListModel,
  ShippingService,
  FlightListModel,
  FlightService,
  BillService,
  ListFlightByShippingRQ
} from "app/open-api";
import { AssigmentDealerLocalModel, AssigmentDealerToExport } from 'app/shared/models/assigment-dealer.model';
import { environment } from 'environments/environment';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ShippingListRQ } from '../../open-api/model/ShippingListRQ';
import { GetBillsForDispatchRQ } from './../../open-api/model/getBillsForDispatchRQ';
import { ListDispatchByParamsRQ, ListDispatchByParamsRP, DispatchBillModel, DispatchBillModelLocal, DispatchToExport, DispatchModel, DispatchModelLocal } from './../../open-api/model/listDispatchByParamsRQ';
import { AddDispatchToDealerRQ } from './../../open-api/model/addDispatchToDealerRQ';
import { DeleteDispatchRQ, DeleteDispatchRP, DeleteBillDispatchRQ, DeleteBillDispatchRP } from './../../open-api/model/deleteDispatchRQ';
import { ShippingType, shippingTypes } from './../../open-api/model/shippingType';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-bills-to-dispatch",
  templateUrl: "./bills-to-dispatch.component.html",
  styleUrls: ["./bills-to-dispatch.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class BillsToDispatchComponent implements OnInit {
  @ViewChild("myTable") table: any;
  @ViewChild("popOver") public popover: NgbPopover;
  public shippings: ShippingListModel[] = [];
  public dealers: DealerModel[] = [];
  public assigments: AssigmentDealerModel[] = [];
  flights: FlightListModel[] = [];
  public assignments: AssigmentDealerLocalModel[] = [];
  selectedAssignment: AssigmentDealerLocalModel;
  selectedBillAssignments: AssigmentDealerLocalModel[] = [];
  public allAssignments: AssigmentDealerLocalModel[] = [];
  selectedDealerId = "";
  dispatchs: DispatchModelLocal[] = [];
  public ColumnMode = ColumnMode;
  urlApi = environment.apiUrl;
  public basicSelectedOption: number = 5;
  searchForDealer: GetBillsForDispatchRQ;
  selected = [];
  canCheck: false;
  public SelectionType = SelectionType;
  filterForm: FormGroup;
  shippingTypes: Array<ShippingType> = []; 
  totalRecords = 0; // Total number of records
  //totalPounds = 0; // Total number of records
  //totalPaid = 0;
  pageSize = 10; // Rows per page
  page = 1; // Current page index
  loading = false;
  pageIndex = 0;
  currentfilter: ListDispatchByParamsRQ;

  constructor(
    private assigmentService: AssigmentService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private billService: BillService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private dealerService: DealerService,
    private fb: FormBuilder
  ) {
    this.shippingTypes = shippingTypes;
    this.filterForm = fb.group({
      dealerId: [null],
      code: [""],
      startDate: [""],
    });
  }

  ngOnInit() {
    this.FetchModel();
    this.FetchDispatchs();
  }

  get fd() {
    return this.filterForm.controls;
  }

  GroupedShippings(row: any) {}

  groupBy(data: any[], key: string) {
    return data.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  }

  getHeight(row: any): number {
    if (row) {
      return row.someHeight;
    }
  }

  openPopover() {
    this.popover.open();
  }

  public closePopover(): void {
    //this.maskEditorAppliedMessage = null;
    if (this.popover.isOpen()) this.popover.close();
  }

  applyFilters() {}

  resetFilters() {
    this.filterForm.reset();
    this.FetchDispatchs();
  }

  GetNameShippingType(type: number) {
    return this.shippingTypes.find((b) => b.id === type).name;
  }

  DeleteBillInDispatch(billId: any) {        
    
    const swal = Swal.fire({
      title: "¿Está seguro que desea eliminar la factura del despacho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.searchForDealer = this.filterForm.value;
        const request: DeleteBillDispatchRQ = {
          dispatchBillId: billId.billDispatchId,
        };

        this.assigmentService.apiDispatchBillDeletePost(request).subscribe(
          (response) => {
            Swal.fire({
              title: `La factura ha sido desasignada del despacho.`,
              icon: "success",
              showConfirmButton: false,
              timer: 3000,
              position: "top",
            });

            setTimeout(() => {
              this.FetchDispatchs();
            }, 3005);

            this.spinner.hide();
          },
          (error) => {
            Swal.fire({
              title: "Error! " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        );
      }
    });
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  onDetailToggle(event) {
    //console.log('Detail Toggled', event);
  }

  exportDispatch(dispatchId: number){
    const swal = Swal.fire({
      title: "Escoja la opción de exportar datos.",      
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Excel",
      cancelButtonText: "PDF",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      //console.log(result)
      if (result.isConfirmed) {
        this.exportexcel(dispatchId);
      }
      else if (result.isDismissed && result.dismiss == Swal.DismissReason.cancel){
        this.generatePDF(dispatchId);
      }
    })
  }

  

  exportList(dispatch: DispatchModelLocal): DispatchToExport[] {
    let exportflights: DispatchToExport[] = [];
    //const dispatchToExport = this.GetLocalDispatchById(dispatchId);
    if (dispatch)
      dispatch.dispatchBillsToExport.forEach((row) => {
        let now: DispatchToExport = this.GetDispatchToExport(row);
        exportflights.push(now);
      });  
      return exportflights;  
  }

  GetDispatchToExport(row: DispatchBillModelLocal) {  

    let ret: DispatchToExport = {
       NO_FACTURA: row.code,
       TIPO_ENVIO: row.shippingType,
       PESO: row.pounds.toString(),
       A_PAGAR: row.price.toFixed(2),
       MUNICIPIO: row.customerModel.City.Name,
       NO_ENVIO: row.shippingCode,             
       CODIGO_AVA: row.serviceCode
    };
    return ret;
  }

  exportexcel(idDispatch: number): void {
    /* pass here the data source */
    const dispatchToExport = this.GetLocalDispatchById(idDispatch);
    let exportobj: any = this.exportList(dispatchToExport); 
    
    const header = [
      ['Repartidor: ' + dispatchToExport.dealer.userName, 'Despacho: ' + dispatchToExport.name, 'Fecha: ' + this.datePipe.transform(dispatchToExport.createAt, "MMM/dd/yyyy")]];

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    
    XLSX.utils.sheet_add_json(ws, exportobj, { origin: 'A2',  skipHeader: false });
    XLSX.utils.sheet_add_aoa(ws, header, { origin: 'A1' });    

    ws['!cols'] = [
      { wch: 20, level: 1 }, // Width for Column A
      { wch: 20, level: 2 }, // Width for Column B
      { wch: 20, level: 1 }, // Width for Column C    
      { wch: 20, level: 1 },
      { wch: 18, level: 1 },
      { wch: 18, level: 1 },
      { wch: 18, level: 1 },  
    ];

    var f = XLSX.utils.aoa_to_sheet([
      ["A", "B", "C"],
      [1, 2, { t: "n", f: "SUM(A2:B2)" }],
      [3, 4, { t: "n", f: "A3+B3" }]
    ]);
    
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let newDate: Date = new Date();
    const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");
    let fileName: any = `resumen del despacho _${dispatchToExport.name}_${fecha}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  getCountForGroupingCriteria(seekType: string, dispatch: DispatchModelLocal){
    let found = false;
    for (let [type, value] of Object.entries(dispatch.dispatchBills)) {
      //console.log(type)
      //console.log(value)
      if(type == seekType)
        found = true;
    }    
    return found;
  }

  generatePDF(idDispatch: number) {
    this.spinner.show();
    let header1 = "Carga Aérea";
    let totalLibras1: number = 0;
    let total1 = 0;
    let totalLibras2: number = 0;
    let total2 = 0;
    const contenido1: string[][] = [];
    let header2 = "Regular"
    const contenido2: string[][] = [];
    const dispatchToExport = this.GetLocalDispatchById(idDispatch);
    let checkHeader1 = this.getCountForGroupingCriteria(header1, dispatchToExport)
    let checkHeader2 = this.getCountForGroupingCriteria(header2, dispatchToExport)

    //console.log(this.getCountForGroupingCriteria(header1, dispatchToExport))
    //console.log(this.getCountForGroupingCriteria(header2, dispatchToExport))

    if(checkHeader1)
       contenido1.push(["CODIGO", "TIPO VUELO", "PESO", "A PAGAR",  "MUNICIPIO", "CODIGO AVA"]);
      else contenido1.push(["", "", "", "",  "", ""]);

    if(checkHeader2)
       contenido2.push(["CODIGO", "TIPO VUELO", "PESO", "A PAGAR",  "MUNICIPIO", "CODIGO AVA"]);
      else contenido2.push(["", "", "", "",  "", ""]);

    const header = [
      ['Repartidor: ' + dispatchToExport.dealer.userName, 'Despacho: ' + dispatchToExport.name, 'Fecha: ' + this.datePipe.transform(dispatchToExport.createAt, "MMM/dd/yyyy")]];
    
    let entries = Object.entries(dispatchToExport.dispatchBills)    
    //console.log(entries.find(item => item[0] === "Carga Aérea" && item[1] !== undefined))
    //console.log(entries.find(item => item[0] === "Regular").length)
    
    
    Object.keys(dispatchToExport.dispatchBills).map((e, index, values )=>{
      if(e === "Carga Aérea"){
        total1 = dispatchToExport.dispatchBills[e].length;
        dispatchToExport.dispatchBills[e].forEach((b, index) => {
          totalLibras1 += (b.price * b.pounds) + b.services;
          
          contenido1.push([            
            b.code,
            b.shippingType,
            b.pounds.toFixed(2),
            b.price.toString(),            
            b.customerModel.City.Name,        
            b.serviceCode,
          ]);          
        });

        contenido1.push([
          "Total"+ total1,
          "",
          "",                    
          "Total a pagar: "+ totalLibras1, 
          "",         
          "",          
        ]);
      }
      else if(e === "Regular"){
        total2 = dispatchToExport.dispatchBills[e].length;
        dispatchToExport.dispatchBills[e].forEach((b, index) => {
          totalLibras2 += (b.price * b.pounds) + b.services;
          console.log('total', b.total);
          contenido2.push([           
            b.code,
            b.shippingType,
            b.pounds.toFixed(2),
            b.price.toString(),            
            b.customerModel.City.Name,        
            b.serviceCode,
          ]);
        });
        contenido2.push([
          "Total: " + total2,
          "",
          "",
          "Total a pagar: " + totalLibras2,
          "",                    
          "",          
        ]);
      }      
     })   

    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            {
              text: "Reporte Resumen de despachos.",
              style: ["title"],
              margin: [0, 10],
            },
          ],
        },
        {
          text: "Nombre: " + dispatchToExport.name,
          style: ["title"],
          margin: [0, 0],
        },
        {
          text: "Repartidor: " + dispatchToExport.dealer.userName,
          style: ["title"],
          margin: [0, 0],
        },
        {
          text: "Fecha: " + this.datePipe.transform(new Date(), "MMM/dd/yyyy"),
          style: ["title"],
          margin: [0, 0],
        },        
        {
          text: checkHeader1 ? header1 : "",
          style: ["title"],
          margin: [0, 10, 0, 10],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido1,

          },
          margin: [0, 0],
        },
        {
          text: checkHeader2 ? header2 : "",
          style: ["title"],
          margin: [0, 10, 0, 10],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido2,
          },
          margin: [0, 0],
        }        
      ],
      styles: {
        title: {
          fontSize: 18,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }

  columnsToDisplay = ["code", "total"];

  ModelDispatchParse(array: DispatchModel[]): DispatchModelLocal[] {
    return array.map(({ dispatchBills, id, status, ...rest }) => ({
      ...rest,
      accions: {
        id: id,
        status: status,
      },
      id: id,
      status: status,
      dispatchBills: this.groupBy(
        this.ModelBillDispatchParse(dispatchBills),
        "shippingType"
      ),
      dispatchBillsToExport: this.ModelBillDispatchParse(dispatchBills)
    }));
  }

  expanded1: { [key: string]: boolean } = {};

  toggleExpand(key: string) {
    this.expanded1[key] = !this.expanded1[key];
  }

  ModelBillDispatchParse(array: DispatchBillModel[]): DispatchBillModelLocal[] {
    return array.map(({ bill, id, ...rest }) => ({
      ...rest,
      code: bill.code,
      createAt: bill.createAt,
      customerModel: JSON.parse(bill.customerModel || ""),
      senderModel: JSON.parse(bill.senderModel || ""),
      pounds: bill.pounds,
      price: bill.price,
      serviceCode: bill.serviceCode,
      shippingCode: bill.shippingCode,
      shippingType: this.GetNameShippingType(bill.shippingType),
      stateCatalogName: bill.stateCatalogName,
      stateCatalogId: bill.stateCatalogId,
      services: bill.services,
      total: bill.total,
      idCodes: {
        billId: bill.id,
        code: bill.code,
        serviceCode: bill.serviceCode,
        stateCatalogId: bill.stateCatalogId,
        billDispatchId: id,
      },
    }));
  }

  ToDate() {
    if (
      this.filterForm.get("startDate").value != "" &&
      this.filterForm.get("startDate").value != undefined
    ) {
      const day = this.filterForm.get("startDate").value.day;
      const month = this.filterForm.get("startDate").value.month;
      const year = this.filterForm.get("startDate").value.year;
      return new Date(year, month - 1, day);
    } else return null;
  }

  GetTotalPaid(item) {       
    let total = 0;    
    item.forEach((row) => {
      total += row.total;
    });  
    return total;
  }

  GetLocalDispatchById(id: number){
    return this.dispatchs.find(item => item.id === id);
  }

  FilterDispatchs() {
    this.spinner.show();
    let startDate = this.ToDate()?.toDateString();
    let code = this.filterForm.controls["code"].value;
    this.currentfilter = {
      dealerId: this.filterForm.controls["dealerId"].value,
      code: code ? code : null,
      startDate: startDate ? startDate : null,
    };
    this.assigmentService.apiDispatchListViewPost(this.currentfilter).subscribe(
      (response) => {
        this.dispatchs = this.ModelDispatchParse(response.list);
        this.totalRecords = response.totalRecords;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  FilterHasValues() {
    if (this.currentfilter != null) {
      return (
        this.currentfilter.code != null ||
        this.currentfilter.dealerId != null ||
        this.currentfilter.startDate != null 
      );
    }
    return false;
  }

  onPageChange(pageNumber: any): void {
    this.page = pageNumber.page;    
    this.FetchDispatchs();    
  }

  FetchDispatchs() {
    this.spinner.show();
    this.searchForDealer = this.filterForm.value;
    const request: ListDispatchByParamsRQ = {
      //dealerId: this.searchForDealer.dealerId
      pageNumber: this.page,
      pageSize: this.basicSelectedOption,  
    };

    this.assigmentService.apiDispatchListViewPost(request).subscribe(
      (response) => {        
        this.dispatchs = this.ModelDispatchParse(response.list);
        this.totalRecords = response.totalRecords;
        //this.totalPounds = response.totalPounds;
        //this.totalPaid = response.totalPounds;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  OnDealerChange() {
    if (
      this.filterForm.get("dealerId").value != null &&
      this.filterForm.get("dealerId").value != ""
    )
      this.selectedDealerId = this.filterForm.get("dealerId").value;
    else this.selectedDealerId = "";

    this.FetchDispatchs();
  }

  async DeleteDispatch(dispatchId: number) {
    const swal = Swal.fire({
      title: "¿Está seguro que desea eliminar el despacho?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Procesar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.searchForDealer = this.filterForm.value;
        const request: DeleteDispatchRQ = {
          dispatchId: dispatchId,
        };

        this.assigmentService.apiDeleteDispatchPost(request).subscribe(
          (response) => {
            Swal.fire({
              title: `El despacho ha sido eliminado satisfactoriamente.`,
              icon: "success",
              showConfirmButton: false,
              timer: 3000,
              position: "top",
            });

            setTimeout(() => {
              this.FetchDispatchs();
            }, 3005);

            this.spinner.hide();
          },
          (error) => {
            Swal.fire({
              title: "Error! " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        );
      }
    });
  }

  FetchModel() {
    const request: ShippingListRQ = {};

    this.dealerService.apiDealerDetailsListGet().subscribe((response) => {
      this.dealers = response.list;
    }),
      (error) => {
        Swal.fire({
          title: "Error!. " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
      };
  }

  onSelect({ selected }) {
    this.selectedBillAssignments = selected as AssigmentDealerLocalModel[];
    this.selectedAssignment =
      this.selectedBillAssignments[this.assignments.length - 1];
    //console.log(this.selectedBill, this.selectedBills);
  }

  onCheckboxChangeFn(event: any, code: string) {
    console.log("event", event);
    console.log("code", code);
  }

  ModelParse(array: AssigmentDealerModel[]): AssigmentDealerLocalModel[] {
    return array.map(({ billCustomerModel, billSenderModel, ...rest }) => ({
      ...rest,
      billCustomerModel: JSON.parse(billCustomerModel || ""),
      billSenderModel: JSON.parse(billSenderModel || ""),
    }));
  }

  ConvertDate(paramDate: Date) {
    const newDate = this.datePipe.transform(paramDate, "MMM/dd/yyyy");
    //console.log("defaultDate", defaultDate)
    return "Jan/01/0001" == newDate ? "" : newDate;
  }

  /*ModelDispatchParse(array: DispatchModel[]): AssigmentDealerLocalModel[] {
    return array.map(({ billCustomerModel, billSenderModel, ...rest }) => ({
      ...rest,
      billCustomerModel: JSON.parse(billCustomerModel || ''),
      billSenderModel: JSON.parse(billSenderModel || '')
    }));
  }*/

  GetURLById(id: number) {
    const bill = this.assignments.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.billFile;
  }

  GetCodeById(id: number) {
    const bill = this.assignments.find((b) => b.billId === id);
    return bill.billCode;
  }

  GetServiceCodeById(id: number) {
    const bill = this.assignments.find((b) => b.billId === id);
    return bill.serviceCode;
  }

  totalPounds() {
    if (this.assignments.length > 0) {
      let sum = this.assignments.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.billPounds).toFixed(2));
      }, 0);
      return sum;
    }
    return 0;
  }

  totalPaid() {
    let sum = this.assignments.reduce((accumulator, item) => {
      return accumulator + Number(item.billTotal.toFixed(2));
    }, 0);
    return sum;
  }
}
